import type { ReactNode } from 'react'

import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
} from '@/components/ui/sheet'

import type { useDraftAgencyPreviewChat } from '@/hooks/use-draft-agency-preview-chat.hook'
import { AgencyPreviewChatContent } from './agency-preview-chat-content.atom'
import { AgencyPreviewChatHeader } from './agency-preview-chat-header.atom'
import { AgencyPreviewChatTrigger } from './agency-preview-chat-trigger.atom'

interface AgencyPreviewChatMobileProps {
  state: ReturnType<typeof useDraftAgencyPreviewChat>['state']
  handlers: ReturnType<typeof useDraftAgencyPreviewChat>['handlers']
  conversationId: string | null
  className?: string
}

export const AgencyPreviewChatMobile = ({
  state,
  handlers,
  conversationId,
  className,
}: AgencyPreviewChatMobileProps): ReactNode => (
  <>
    <AgencyPreviewChatTrigger onClick={handlers.handleOpen} className={className} />
    <Sheet open={state.isOpen} onOpenChange={(open) => !open && handlers.handleClose()}>
      <SheetContent
        side="right"
        className="agency-preview-chat-drawer flex w-full flex-col p-0 sm:max-w-md"
      >
        <SheetHeader className="sr-only">
          <SheetTitle>Test Chat</SheetTitle>
          <SheetDescription>Preview your agency responses</SheetDescription>
        </SheetHeader>
        <AgencyPreviewChatHeader onClose={handlers.handleClose} onReset={handlers.handleReset} />
        <div className="flex-1 overflow-hidden">
          <AgencyPreviewChatContent
            state={state}
            handlers={handlers}
            conversationId={conversationId}
          />
        </div>
      </SheetContent>
    </Sheet>
  </>
)

AgencyPreviewChatMobile.displayName = 'AgencyPreviewChatMobile'
